export default __webpack_public_path__ + "static/governors-mansion-1612734_1280-be460bb2e94f67386466c26559f6f3a1.png";